module.exports = __webpack_public_path__ + "img/logo-vgem-bad-neustadt.17f2d0d4.svg";